import React, { useEffect, useState } from "react";
import { mainTableFields } from "./maintable";

const MainTable = ({ onObjectReceived, newDataa, isDisbursed }) => {
  const [fieldVal, setFieldVal] = useState({
    totalCows: 0,
    totalBuffalo: 0,
    totalCattle: 0,
    activeCows: 0,
    activeBuffalo: 0,
    activeCattle: 0,
    cowMilkProduction: 0,
    buffaloMilkProduction: 0,
    totalMilkProduction: 0,
    perDayCowMilkProduction: 0,
    perDayBuffaloMilkProduction: 0,
    perDayMilkProduction: 0,
    supplyForCowCorp: 0,
    supplyForBuffaloCorp: 0,
    supplyForCorp: 0,
    cowMarketSale: 0,
    buffaloMarketSale: 0,
    totalMarketSale: 0,
    perLtrCowSellCorp: 0,
    perLtrBuffaloSellCorp: 0,
    perLtrTotalSellCorp: 0,
    perLtrCowSellMkt: 0,
    perLtrBuffaloSellMkt: 0,
    perLtrTotalSellMkt: 0,
    perLtrCowSellAvg: 0,
    perLtrBuffaloSellAvg: 0,
    perLtrTotalSellAvg: 0,
    perLtrCowSellGross: 0,
    perLtrBuffaloSellGross: 0,
    perLtrTotalSellGross: 0,
    costOfCowFeed: 0,
    CostOfBuffaloFeed: 0,
    feedTotalCost: 0,
    costOfCowFeedPerCattle: 0,
    CostOfBuffaloFeedPerCattle: 0,
    feedTotalCostPerCattle: 0,
    setCowBreed: "",
    setBuffaloBreed: "",
    perDayCowGross: 0,
    perDayBuffaloGross: 0,
    perDayTotalGross: 0,
    perMonthPerCowCost: 0,
    perMonthPerBuffaloCost: 0,
    totalPerMonthPerCattleCost: 0,
    costOfCowFeedPerCattlePerMonth: 0,
    costOfBuffaloFeedPerCattlePerMonth: 0,
    feedTotalCostPerCattlePerMonth: 0,
    totalCostOfCowPerMonth: 0,
    totalCostOfBuffaloPerMonth: 0,
    totalCostOfCattlePerMonth: 0,
    cowNetIncomePerMonth: 0,
    buffaloNetIncomePerMonth: 0,
    totalNetIncomePerMonth: 0,
  });

  useEffect(() => {
    if(newDataa !== undefined){
      setFieldVal(newDataa);
    }
  }, [newDataa]);

  // console.log(fieldVal);
  useEffect(() => {
    mainTableFields.forEach((field) => {
      if (!field.NA) {
        setFieldVal((prevState) => ({
          ...prevState,
          [field.total]:
            Number(prevState[field.cowState]) +
            Number(prevState[field.buffaloState]),
        }));
      }
    });
  }, [
    fieldVal.cowMilkProduction,
    fieldVal.buffaloMilkProduction,
    fieldVal.perDayCowGross,
    fieldVal.perDayBuffaloGross,
  ]);

  useEffect(() => {
    onObjectReceived(fieldVal);
    // eslint-disable-next-line
  }, [fieldVal]);

  const updateVal = (state) => {
    return (e) => {
      setFieldVal((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));

      mainTableFields.forEach((field) => {
        if (!field.NA) {
          setFieldVal((prevState) => ({
            ...prevState,
            [field.total]:
              Number(prevState[field.cowState]) +
              Number(prevState[field.buffaloState]),
          }));
        }
      });

      setFieldVal((prevState) => ({
        ...prevState,
        cowMilkProduction:
          Number(prevState.activeCows) *
          Number(prevState.perDayCowMilkProduction),
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        buffaloMilkProduction:
          Number(prevState.activeBuffalo) *
          Number(prevState.perDayBuffaloMilkProduction),
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        perLtrCowSellAvg: Number((prevState.supplyForCowCorp / 100) * prevState.perLtrCowSellCorp + (prevState.cowMarketSale / 100) * prevState.perLtrCowSellMkt),
        perLtrBuffaloSellAvg: Number((prevState.supplyForBuffaloCorp / 100) * prevState.perLtrBuffaloSellCorp + (prevState.buffaloMarketSale / 100) * prevState.perLtrBuffaloSellMkt),
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        perDayCowGross:
          prevState.cowMilkProduction * prevState.perLtrCowSellAvg,
        perDayBuffaloGross:
          prevState.buffaloMilkProduction * prevState.perLtrBuffaloSellAvg,
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        perLtrCowSellGross: prevState.perDayCowGross * 30,
        perLtrBuffaloSellGross: prevState.perDayBuffaloGross * 30,
      }));

      // setFieldVal((prevState) => ({
      //   ...prevState,
      //   // perMonthPerCowCost: 8400,
      //   perMonthPerCowCost: Number(prevState.perMonthPerCowCost) ? Number(prevState.perMonthPerCowCost) : 0,
      //   // perMonthPerBuffaloCost: 8400,
      //   perMonthPerBuffaloCost: Number(prevState.perMonthPerBuffaloCost) ? Number(prevState.perMonthPerBuffaloCost) : 0,
      // }));

      setFieldVal((prevState) => ({
        ...prevState,
        totalCostOfCowPerMonth:
          prevState.perMonthPerCowCost * prevState.totalCows,
        totalCostOfBuffaloPerMonth:
          prevState.perMonthPerBuffaloCost * prevState.totalBuffalo,
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        cowNetIncomePerMonth:
          prevState.perLtrCowSellGross - prevState.totalCostOfCowPerMonth,
        buffaloNetIncomePerMonth:
          prevState.perLtrBuffaloSellGross -
          prevState.totalCostOfBuffaloPerMonth,
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        totalCostOfCattlePerMonth:
          prevState.totalCostOfCowPerMonth + prevState.totalCostOfBuffaloPerMonth,
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        totalNetIncomePerMonth:
          prevState.buffaloNetIncomePerMonth + prevState.cowNetIncomePerMonth,
      }));

      setFieldVal((prevState) => ({
        ...prevState,
        totalMarketSale: prevState.totalMarketSale ?? 0,
        cowMarketSale: prevState.cowMarketSale ?? 0,
        buffaloMarketSale: prevState.buffaloMarketSale ?? 0,
        perLtrCowSellMkt: prevState.perLtrCowSellMkt ?? 0,
        perLtrBuffaloSellMkt: prevState.perLtrBuffaloSellMkt ?? 0,
        perMonthPerCowCost: prevState.perMonthPerCowCost ?? 0,
        perMonthPerBuffaloCost: prevState.perMonthPerBuffaloCost ?? 0
      }));
      
    };
  };

  console.log(fieldVal)
  return (
    <section>
      <div className="obligations-container">
        <h3 style={{
          textAlign: "center",
          fontSize: "1.2rem",
          fontWeight: "bold",
          marginBottom: "0.5rem",
          color: "black",
        }}>
          Cattle Income Calculator at HH level
        </h3>
        <table className="report-table-maincamtable" style={{margin:"auto"}}>
          <thead style={{ backgroundColor: 'rgb(207, 226, 243)'}}>
            <tr>
              <th style={{border :'1px solid black'}} >Particulars</th>
              <th style={{border :'1px solid black'}}>Cow</th>
              <th style={{border :'1px solid black'}}>Buffalo</th>
              <th style={{border :'1px solid black'}}>Total</th>
            </tr>
          </thead>
          <tbody>
            {mainTableFields.map((fields) => {
              return (
                <React.Fragment key={fields.name}>
                  {fields.input === "text" ? (
                    <tr key={fields.name}>
                      <td style={{border :'1px solid black'}}>{fields.name}</td>
                      <td style={{border :'1px solid black'}}>
                        <input
                          type="number"
                          // style={{ width: "60px" }}
                          style={{
                            width: "60px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "2px 4px",
                            backgroundColor: "#fff",
                            boxSizing: "border-box",
                          }}
                          onChange={updateVal(fields.cowState)}
                          value={fieldVal[fields.cowState]}
                          disabled={fields.disabled || isDisbursed}
                        />
                      </td>
                      <td style={{border :'1px solid black'}}>
                        <input
                          type="number"
                          // style={{ width: "60px" }}
                          style={{
                            width: "60px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "2px 4px",
                            backgroundColor: "#fff",
                            boxSizing: "border-box",
                          }}
                          value={fieldVal[fields.buffaloState]}
                          onChange={updateVal(fields.buffaloState)}
                          disabled={fields.disabled || isDisbursed}
                        />
                      </td>
                      <td style={{border :'1px solid black'}}>{fieldVal[fields.total]}</td>
                    </tr>
                  ) : (
                    <tr key={fields.name}>
                      <td style={{border :'1px solid black'}}>{fields.name}</td>
                      <td style={{border :'1px solid black'}}>
                          <select
                            // style={{ width: "60px" }}
                            style={{
                              width: "60px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "2px 4px",
                              backgroundColor: "#fff",
                              boxSizing: "border-box",
                            }}
                            disabled={isDisbursed}
                            onChange={updateVal([fields.cowState])}
                          >
                          {fields.cowOptions.map((opt) => {
                            return (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            );
                          })}
                        </select>
                      </td>
                      <td style={{border :'1px solid black'}}>
                          <select
                            // style={{ width: "60px" }}
                            style={{
                              width: "60px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "2px 4px",
                              backgroundColor: "#fff",
                              boxSizing: "border-box",
                            }}
                            onChange={updateVal([fields.buffaloState])}
                            disabled={isDisbursed}
                          >
                            {fields.buffaloOptions.map((opt) => {
                            return (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            );
                          })}
                        </select>
                      </td>
                      <td  style={{border :'1px solid black'}}>{fields.total}</td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default MainTable;
